import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-portal-button',
    templateUrl: './portal-button.component.html',
    styleUrls: ['./portal-button.component.scss']
})
export class PortalButtonComponent {
    @Input({ required: true }) title!: string;
    @Input({ required: false }) link!: string;
    @Input({ required: false }) target!: string;
    @Input({ required: false }) color!: string;
    @Input({ required: false }) classes!: string;
}